import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { BASE_URL } from "../config/config";
import { useAuth } from "../context/AuthContext";
import logo from '../assets/images/icons/logo.png'

const Header = () => {   
  const [isCartOpen, setCartOpen] = useState(false);
  const [isProfileOpen, setProfileOpen] = useState(false);
  const { isLoggedIn, user, setIsLoggedIn } = useAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const [lastSearch, setLastSearch] = useState("");
  const { cartItems, cartCount, deleteCartItem, clearCart } = useCart();
  const navigate = useNavigate();

  const toggleCart = () => setCartOpen(!isCartOpen);
  const closeCart = () => setCartOpen(false);
  const toggleProfile = () => setProfileOpen(!isProfileOpen);
  const location = useLocation();

  const handleCheckout = () => {
    if (cartItems.length === 0) return;

    if (isLoggedIn) {
      navigate("/checkout");
    } else {
      navigate("/login", { state: { from: "/checkout" } });
    }
    setCartOpen(false);
  };

  useEffect(() => {
    const q = new URLSearchParams(location.search).get("q") || "";
    setSearchTerm(q);
    setLastSearch(q);
  }, []);
  const handleLogout = () => {
    sessionStorage.removeItem("authToken");
    setIsLoggedIn(false);
    clearCart();
    navigate("/login");
  };

  useEffect(() => {
    const trimmed = searchTerm.trim();

    const timer = setTimeout(() => {
      if (trimmed.length >= 3 && trimmed !== lastSearch) {
        navigate(`/search?q=${encodeURIComponent(trimmed)}`);
        setLastSearch(trimmed);
      }

      if (trimmed.length === 0 && lastSearch !== "") {
        navigate("/search?q=");
        setLastSearch("");
      }
    }, 400);

    return () => clearTimeout(timer);
  }, [searchTerm]);
  useEffect(() => {
    if (!location.pathname.startsWith("/search")) {
      setSearchTerm("");
      setLastSearch("");
    }
  }, [location.pathname]);

  return (
    <>
      {/* Top Bar */}
      <div
        className="py-2"
        style={{
          background: "linear-gradient(90deg,#2563eb,#4f46e5,#7c3aed)",
          color: "#fff",
          fontSize: "14px",
        }}
      >
        <div className="container d-flex justify-content-between align-items-center small pt-1">
          <div className="d-flex align-items-center gap-2">
            {/* <i className="fa-solid fa-truck-fast"></i>
            <span>Free Shipping on Orders Above ₹999</span> */}
          </div>
          <div className="d-flex gap-3">
            {" "}
            <span>
              {" "}
              <i className="fa-solid fa-shield-halved me-1"></i> Secure
              Payments{" "}
            </span>{" "}
            <span>
              {" "}
              <i className="fa-solid fa-headset me-1"></i> 24/7 Support{" "}
            </span>{" "}
          </div>
          {!isLoggedIn ? (
            <div className="d-flex align-items-center gap-3">
              <Link
                to="/login"
                className="text-white text-decoration-none fs-6"
              >
                Login
              </Link>
              <span>|</span>
              <Link
                to="/register"
                className="text-white text-decoration-none fs-6"
              >
                Register
              </Link>
            </div>
          ) : (
            <div className="d-flex align-items-center gap-3">
              <div className="dropdown">
                <button
                  className="btn btn-link text-white text-decoration-none fs-6 dropdown-toggle p-0 d-flex align-items-center"
                  onClick={toggleProfile}
                >
                  <div
                    className="rounded-circle bg-secondary d-flex align-items-center justify-content-center me-2"
                    style={{ width: "24px", height: "24px" }}
                  >
                    <i
                      className="fas fa-user text-white"
                      style={{ fontSize: "12px" }}
                    ></i>
                  </div>
                  {user?.name || "Profile"}
                </button>
                <div
                  className={`dropdown-menu dropdown-menu-end ${
                    isProfileOpen ? "show" : ""
                  }`}
                  style={{ zIndex: 999999 }}
                >
                  <Link
                    className="dropdown-item"
                    to="/my-profile"
                    onClick={() => setProfileOpen(false)}
                  >
                    <i className="fas fa-user me-2"></i> My Profile
                  </Link>
                  {/* <Link
                    className="dropdown-item"
                    to="/order"
                    onClick={() => setProfileOpen(false)}
                  >
                    <i className="fas fa-box me-2"></i> My Orders
                  </Link> */}
                  <div className="dropdown-divider"></div>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      handleLogout();
                      setProfileOpen(false);
                    }}
                  >
                    <i
                      className="fas fa-sign-out-alt me-2"
                      onClick={handleLogout}
                    ></i>{" "}
                    Logout
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Main Navigation */}
      <header
        className="sticky-top"
        style={{
          background: "rgba(255,255,255,.96)",
          backdropFilter: "blur(12px)",
          boxShadow: "0 4px 30px rgba(0,0,0,.06)",
          zIndex: 999,
        }}
      >
        <nav className="navbar navbar-expand-lg container py-2">
          <Link className="navbar-brand" to="/">
            {" "}
            <img
              src={logo}
              alt="Logo"
              height={80}
              width={80}
              className="img-fluid"
            />{" "}
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <i className="fa-solid fa-bars"></i>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto gap-lg-3">
              {" "}
              <li className="nav-item">
                {" "}
                <NavLink className="nav-link fw-semibold" to="/">
                  {" "}
                  Home{" "}
                </NavLink>{" "}
              </li>{" "}
              <li className="nav-item">
                {" "}
                <NavLink className="nav-link fw-semibold" to="/shop">
                  {" "}
                  Shop{" "}
                </NavLink>{" "}
              </li>{" "}
              <li className="nav-item">
                {" "}
                <NavLink className="nav-link fw-semibold" to="/about">
                  {" "}
                  About{" "}
                </NavLink>{" "}
              </li>{" "}
              <li className="nav-item">
                {" "}
                <NavLink className="nav-link fw-semibold" to="/contact">
                  {" "}
                  Contact{" "}
                </NavLink>{" "}
              </li>{" "}
            </ul>

            {/* Search & Cart */}
            {/* <div
              className="position-relative d-none d-lg-block"
              style={{ width: "320px" }}
            >
              {" "}
              <input
                className="form-control rounded-pill ps-5 border-0 shadow-sm"
                placeholder="Search products..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ height: "48px", background: "#f8fafc" }}
              />{" "}
              <i
                className="fa-solid fa-magnifying-glass position-absolute"
                style={{ left: "18px", top: "16px", color: "#64748b" }}
              />{" "}
            </div> */}
            <div className="d-flex align-items-center gap-3">
              {/* Search */}
              <div
                className="position-relative d-none d-lg-block"
                style={{ width: "320px" }}
              >
                <input
                  className="form-control rounded-pill ps-5 border-0 shadow-sm"
                  placeholder="Search products..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    height: "48px",
                    background: "#f8fafc",
                  }}
                />

                <i
                  className="fa-solid fa-magnifying-glass position-absolute"
                  style={{
                    left: "18px",
                    top: "16px",
                    color: "#64748b",
                  }}
                ></i>
              </div>

              {/* Cart */}
              <button
                onClick={toggleCart}
                className="btn btn-light rounded-circle shadow-sm position-relative d-flex align-items-center justify-content-center"
                style={{
                  width: "45px",
                  height: "45px",
                }}
              >
                <i className="fa-solid fa-cart-shopping fs-5"></i>

                {cartCount > 0 && (
                  <span
                    className="position-absolute badge rounded-pill bg-danger"
                    style={{
                      top: "-6px",
                      right: "-6px",
                      fontSize: "11px",
                      minWidth: "20px",
                      height: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {cartCount}
                  </span>
                )}
              </button>
            </div>
          </div>
        </nav>
      </header>

      {/* Cart Sidebar */}
      <div
        className={`wrap-header-cart ${isCartOpen ? "show-header-cart" : ""}`}
      >
        <div className="s-full js-hide-cart" onClick={closeCart}></div>
        <div className="header-cart">
          <div className="header-cart-title d-flex justify-content-between align-items-center">
            <span>Your Cart</span>
            <button
              className="close-btn js-hide-cart border-0 bg-none"
              onClick={closeCart}
            >
              <i className="fa-solid fa-xmark fs-5"></i>
            </button>
          </div>
          <div className="header-cart-content">
            {cartItems.length > 0 ? (
              cartItems.map((item, index) => (
                <ul className="header-cart-wrapitem mb-3" key={index}>
                  <li className="d-flex align-items-start gap-3">
                    {/* Product Image */}
                    <div
                      style={{
                        width: "70px",
                        height: "70px",
                        flexShrink: 0,
                        borderRadius: "10px",
                        overflow: "hidden",
                        border: "1px solid #e5e7eb",
                        background: "#f8f9fa",
                      }}
                    >
                      <img
                        src={`${BASE_URL}/uploads/${item.image}`}
                        alt={item.product_name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    </div>

                    {/* Product Details */}
                    <div className="flex-grow-1 d-flex justify-content-between align-items-start">
                      <div style={{ minWidth: 0 }}>
                        <h3
                          className="fw-bold mb-1"
                          style={{
                            fontSize: "15px",
                            color: "#1f2937",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "180px", // Adjust as needed
                          }}
                          title={item.product_name} // Shows full name on hover
                        >
                          {item.product_name}
                        </h3>

                        <p
                          className="mb-1 text-muted"
                          style={{ fontSize: "14px" }}
                        >
                          ₹{item.price} × {item.quantity}
                        </p>

                        <span
                          className="badge"
                          style={{
                            background: "#eef2ff",
                            color: "#4f46e5",
                            fontSize: "12px",
                            padding: "5px 10px",
                            borderRadius: "20px",
                          }}
                        >
                          Size: {item.size}
                        </span>
                      </div>

                      {/* Delete Button */}
                      <button
                        type="button"
                        className="btn p-0 ms-2 border-0 bg-transparent"
                        onClick={() =>
                          deleteCartItem(
                            item.product_id,
                            item.size,
                            item.cart_id
                          )
                        }
                        style={{
                          flexShrink: 0,
                          color: "#ef4444",
                          transition: "0.3s",
                        }}
                      >
                        <i className="fa-solid fa-circle-xmark fs-5"></i>
                      </button>
                    </div>
                  </li>
                </ul>
              ))
            ) : (
              // Empty Cart Design
              <div className="text-center py-5 px-3">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/2038/2038854.png"
                  alt="Empty Cart"
                  style={{ width: "100px", marginBottom: "15px" }}
                />
                <p className="text-muted mb-2">Your cart is empty</p>
                <Link
                  to="/shop"
                  onClick={closeCart}
                  className="btn btn-sm btn-dark rounded-pill px-3"
                >
                  🛍️ Continue Shopping
                </Link>
              </div>
            )}
          </div>

          {cartItems.length > 0 && (
            <div className="header-cart-footer">
              <div className="header-cart-total">
                Total: ₹{" "}
                {cartItems
                  .reduce((acc, item) => acc + item.price * item.quantity, 0)
                  .toFixed(2)}
              </div>
              <div className="header-cart-buttons">
                <Link
                  to="/cart"
                  onClick={closeCart}
                  className="btn btn-dark text-white w-50"
                >
                  View Cart
                </Link>
                {/* <button
                  onClick={handleCheckout}
                  className="btn btn-dark text-white w-50"
                >
                  Check Out
                </button> */}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Close dropdown when clicking outside */}
      {isProfileOpen && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 1000 }}
          onClick={() => setProfileOpen(false)}
        />
      )}
    </>
  );
};

export default Header;
